<template>
    <div id="title-settings">
        <div class="form-field">
            <label for="title-input" class="form-label">{{ $t('whatsapp_business_api.headerText') }}</label>
            <input
                type="text"
                id="title-input"
                class="form-input"
                :placeholder="$t('whatsapp_business_api.header')"
                v-model="item.title.titleText"
                @input="updateTitleText(item.title.titleText)"
            >
        </div>
        <div class="form-field">
            <label for="subtitle-input" class="form-label">{{ $t('form.subHeaderText') }}</label>
            <input
                type="text"
                id="subtitle-input"
                class="form-input"
                :placeholder="$t('billing.subHeading')"
                v-model="item.title.subTitle"
                @input="updateSubTitleText(item.title.subTitle)"
            >
            <small class="form-description">{{ $t('form.addSmallTextBelowHeader') }}</small>
        </div>
        <div class="form-field">
            <label class="form-label">{{ $t('form.headerSize') }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: titleSize === 'default' }" @click="updateTitleSize('default')">
                    {{ $t('mail.default') }}
                </button>
                <button class="button" :class="{ active: titleSize === 'wide' }" @click="updateTitleSize('wide')">{{ $t('form.wide') }}
                </button>
                <button class="button" :class="{ active: titleSize === 'small' }" @click="updateTitleSize('small')">
                    {{ $t('form.small') }}
                </button>
            </div>
        </div>
        <div class="form-field">
            <label class="form-label">{{ $t('form.textAlignment') }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: textAlign === 'left' }" @click="updateTextAlign('left')">{{ $t("form.left") }}
                </button>
                <button class="button" :class="{ active: textAlign === 'center' }" @click="updateTextAlign('center')">
                    {{ $t("tables.center") }}
                </button>
                <button class="button" :class="{ active: textAlign === 'right' }" @click="updateTextAlign('right')">{{ $t("form.right") }}
                </button>
            </div>
            <small class="form-description">{{ $t("form.chooseHorizontalAlignment") }}</small>
        </div>
        <!--        <div class="option-field">-->
        <!--            <label class="option-label">Alanı gizle</label>-->
        <!--            <div class="toggle">-->
        <!--                <span class="toggle-option" :class="{ active: isHidden }"-->
        <!--                      @click="toggleField">{{ isHidden ? "AÇIK" : "KAPALI" }}</span>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "TitleSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            titleText: this.item.title.titleText,
            subTitleText: this.item.title.subTitle,
            titleSize: this.item.title.titleSize,
            textAlign: this.item.title.titleAlign,
            isHidden: false,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateTitleText(text) {
            this.titleText = text;
            this.$emit("update-title-text", text);
            this.updateField();
        },
        updateSubTitleText(text) {
            this.subTitleText = text;
            this.$emit("update-subtitle-text", text);
            this.updateField();
        },
        updateTitleSize(size) {
            this.titleSize = size;
            this.$emit("update-title-size", size);
            this.updateField();
        },
        updateTextAlign(alignment) {
            this.textAlign = alignment;
            this.$emit("update-text-align", alignment);
            this.updateField();
        },
        toggleField() {
            this.isHidden = !this.isHidden;
            console.log("Field visibility toggled");
        },
        updateField() {
            const updateFields = {
                title: {
                    titleText: this.titleText,
                    subTitle: this.subTitleText,
                    titleSize: this.titleSize,
                    titleAlign: this.textAlign,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields,
            });
        }
    }
};
</script>

<style scoped>
#title-settings {
    padding: 15px;
}

.form-field, .option-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.form-label, .option-label {
    margin-bottom: 5px;
    font-weight: bold;
    color: #333;
}

.form-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f9f9f9;
    color: #333;
    font-size: 16px;
}

.form-description, .option-description {
    margin-top: 5px;
    font-size: 12px;
    color: #666;
}

.button-group {
    display: flex;
}

.button {
    flex: 1;
    padding: 10px;
    margin-right: 5px;
    border: none;
    border-radius: 4px;
    background-color: #e0e0e0;
    color: #333;
    font-size: 14px;
    cursor: pointer;
}

.button.active {
    background-color: #4a90e2;
    color: #fff;
}

.button:last-child {
    margin-right: 0;
}

.toggle {
    display: flex;
    align-items: center;
}

.toggle-option {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f0f0f0;
    color: #333;
    font-size: 14px;
    cursor: pointer;
}

.toggle-option.active {
    background-color: #4a90e2;
    color: #fff;
}
</style>
